import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

export const MenuTriggerDiv = styled.div`
  cursor: pointer;
  margin-top: 32px;
  color: ${theme.colors.mainBlue};
`;

export const MenuItemTriggerDiv = styled.div`
  cursor: pointer;
  padding-left: 8px;
`;

export const MenuItemHeaderDiv = styled.div`
  width: 100%;
  padding-top: 6px;
  padding-bottom: 3px;
  text-align: center;
  color: ${theme.colors.secondary900};
`;
